export default __webpack_public_path__ + "static/media/games_banner.bec9f092.png";